// **************************************************************************************************************
// FUNCTION:    assembleInventoryResortFees
// PARAMETERS:  invMatchID
// DESCRIPTION: This function handles obtaining "Due At Resort" fee data for a specified
//              piece of inventory to display in a modal window
// **************************************************************************************************************
jQuery(function($) {

    function assembleInventoryResortFees(invMatchID) {

        $('body').addClass('loading-body-overlay');

        $.ajax({
            method: "POST",
            url: "/h/resort/AssembleInventoryResortFees",
            data: {invmatchid: invMatchID}
        })
        .done(function (data) {

            var dataJSON       = JSON.parse(data);
            var closeOnOverlay = true;
            var dialogMarkup   = '';

            if (dataJSON !== '') {

                dialogMarkup = dataJSON.modalHTML;

            } else {

                dialogMarkup = '<div>An unexpected error has occurred. Please try again.</div>';
            }

            $('body').removeClass('loading-body-overlay');
            launchInfoDialogWithClass(dialogMarkup, closeOnOverlay, 'l-dialog-inventory-resort-fees');

        });
    }

    $(document.body).on('click', '.js-resort-fees', function() {

        var invMatchID = $(this).data('inv-match-id');

        assembleInventoryResortFees(invMatchID);
    });

    function assembleInventoryLocalResortFees(invMatchID) {

        $('body').addClass('loading-body-overlay');

        $.ajax({
            method: "POST",
            url: "/h/resort/AssembleInventoryLocalResortFees",
            data: {invmatchid: invMatchID}
        })
            .done(function (data) {

                var dataJSON       = JSON.parse(data);
                var closeOnOverlay = true;
                var dialogMarkup   = '';

                if (dataJSON !== '') {

                    dialogMarkup = dataJSON.modalHTML;

                } else {

                    dialogMarkup = '<div>An unexpected error has occurred. Please try again.</div>';
                }

                $('body').removeClass('loading-body-overlay');
                launchInfoDialogWithClass(dialogMarkup, closeOnOverlay, 'l-dialog-inventory-resort-fees');

            });
    }


    $(document.body).on('click', '.js-local-fees', function() {

        var invMatchID = $(this).data('inv-match-id');

        assembleInventoryLocalResortFees(invMatchID);
    });

});

jQuery(function($) {
    function redirectPost(url, data) {

        var form = document.createElement('form');
        form.method = 'POST';
        form.action = url;

        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                var hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = key;
                hiddenField.value = data[key];
                form.appendChild(hiddenField);
            }
        }

        document.body.appendChild(form);
        form.submit();
    }
    window.redirectPost = redirectPost;
});

// *******************************************************
// FUNCTION:    openFeaturedTab
// PARAMETERS:  tabName (the name of the SEO Featured Destination Content tab that we are trying to open)
// DESCRIPTION: This function handles the toggling open and closed of different content sections for SEO Featured Destinations on the Search Results page
// *******************************************************
jQuery(function($) {
    function openFeaturedTab(tabName) {
        $('.js-featured-description').each(function() {
            $(this).hide();
        });
        $(tabName).show();

        $('.btn-featured-tab').each(function() {
            $(this).removeClass('current');
        });
        $(tabName + '-tab').addClass('current');
    }
    window.openFeaturedTab = openFeaturedTab;
});

// *******************************************************
// FUNCTION:    scrollToResortResults
// PARAMETERS:  none
// DESCRIPTION: For user to click on the "View Resorts" button on a Featured Search Item content block, and smooth scroll them
//              down to the list results section of the page
// *******************************************************
jQuery(function($) {
    function scrollToResortResults() {
        $('html, body').animate({
            scrollTop: $('.search-results-anchor').offset().top + (-82)
        }, 300);
    }
    window.scrollToResortResults = scrollToResortResults;
});

// *******************************************************
// FUNCTION:    scrollToFAQs
// PARAMETERS:  none
// DESCRIPTION: Scrolls the user to the FAQ section on initial load of the New Member Welcome page
// *******************************************************
jQuery(function($) {
    function scrollToFAQs() {
        $('html, body').animate({
            scrollTop: $('.frequently-asked-questions').offset().top
        }, 500);
    }
    window.scrollToFAQs = scrollToFAQs;

    if (typeof scrollNewMemberFAQs !== 'undefined') {
        if (scrollNewMemberFAQs === 'enabled') {
            setTimeout(function(){ scrollToFAQs(); }, 500);
        }
    }
});

// *******************************************************
// FUNCTION:    openCustomFAQItem
// PARAMETERS:  ID of the FAQ item to scroll to
// DESCRIPTION: Does a fancy scroll to the desired area of the page
// *******************************************************
jQuery(function($) {
    function openCustomFAQItem(theElement) {

        var $accordionItem = $('#' + theElement);
        var $content       = $accordionItem.find('.accordion-content');
        var $arrow         = $accordionItem.find('.toggle');

        if ($content.is(':visible')) {
            $('html, body').animate({
                scrollTop: $accordionItem.offset().top
            }, 500);
        } else {
            $content.slideDown( 500, function() {
                $arrow.addClass('active');
                $('html, body').animate({
                    scrollTop: $accordionItem.offset().top
                }, 500);
            });
        }
    }
    window.openCustomFAQItem = openCustomFAQItem;

    if (typeof scrollSpecificFAQItem !== 'undefined') {
        if (scrollSpecificFAQItem !== '') {
            setTimeout(function(){ openCustomFAQItem(scrollSpecificFAQItem); }, 500);
        }
    }
});

// *******************************************************
// FUNCTION:    scrollToSection
// PARAMETERS:  ID or class name to scroll to
// DESCRIPTION: Does a fancy scroll to the desired area of the page
// *******************************************************
jQuery(function($) {
    function scrollToSection(theElement) {
        $('html, body').animate({
            scrollTop: $(theElement).offset().top
        }, 500);
    }
    window.scrollToSection = scrollToSection;
});

// *******************************************************
// FUNCTION:    scrollToWaypoint
// PARAMETERS:  ID or class name to scroll to
// DESCRIPTION: Does a fancy scroll to the desired area of the page and marks the tab as active (resort detail)
// *******************************************************
jQuery(function($) {

    $(document.body).on('click', '.js-scroll-resort-reviews', function() {

        scrollOffset = 80;
        scrollToWaypoint('#js-resort-reviews',scrollOffset);
    });

    $(document.body).on('click', '.js-scroll-all-inclusive-information', function() {

        scrollOffset = 0;
        scrollToWaypoint('#js-all-inclusive-information',scrollOffset);
    });

    function scrollToWaypoint(theElement, scrollOffset) {

        $('html, body').animate({
            scrollTop: $(theElement).offset().top - scrollOffset
        }, 500);
    }
    window.scrollToWaypoint = scrollToWaypoint;

    if (typeof scrollToReviews !== 'undefined') {

        if (scrollToReviews === 'enabled') {

            setTimeout(function() {

                scrollOffset = 80;
                scrollToWaypoint('#js-resort-reviews', scrollOffset);
            }, 1000);
        }
    }

    if (typeof scrollToAllInclusiveInformation !== 'undefined') {

        if (scrollToAllInclusiveInformation === 'enabled') {

            setTimeout(function() {

                scrollOffset = 0;
                scrollToWaypoint('#js-all-inclusive-information', scrollOffset);
            }, 1000);
        }
    }

    if (typeof scrollToAvailability !== 'undefined') {

        if (scrollToAvailability === 'enabled') {

            setTimeout(function() {

                scrollOffset = 0;
                scrollToWaypoint('#js-resort-availability', scrollOffset);
            }, 500);
        }
    }
});

// *******************************************************
// FUNCTION:    initResponsiveMenu
// PARAMETERS:  none
// DESCRIPTION: Enables the opening and closing of the responsive site navigation menu
// *******************************************************
jQuery(function initResponsiveMenu($) {
    $('.header-menu').each(function(index, el) {

        var $container = $(this);
        var $button    = $container.find('.responsive-menu-button');
        var $menu      = $container.find('.navigation-main');

        $button.click(function() {
            if ($menu.is(':visible')) {
                $menu.hide();
            } else {
                $menu.show();
            }
        });
    });
});

// *******************************************************
// FUNCTION:    initFAQsToggles
// PARAMETERS:  none
// DESCRIPTION: Toggles (open and closed) accordion related content
// *******************************************************
jQuery(function initFAQsToggles($) {
    $('.js-accordion').each(function(index, el) {

        $(this).find('.accordion-item').each(function(index, el) {
            var $content = $(this).find('.accordion-content');
            var $toggle  = $(this).find('.accordion-title').not('.always-open');
            var $arrow   = $(this).find('.toggle');

            $toggle.click(function() {
                if ($content.is(':visible')) {
                    $arrow.removeClass('active');
                    $content.slideUp(250);
                }
                else {
                    $arrow.addClass('active');
                    $content.slideDown(250);
                }
            });
        });
    });
});

// *******************************************************
// FUNCTION:    initBookToggles
// PARAMETERS:  none
// DESCRIPTION: Toggles (on and off) booking funnel accordion content
// *******************************************************
jQuery(function initBookToggles($) {
    $('.js-book-accordion').each(function(index, el) {

        $('.book-accordion-item').each(function(index, el) {
            var $content = $(this).find('.book-accordion-content');
            var $toggle  = $(this).find('.book-accordion-title');
            var $arrow   = $(this).find('.book-toggle');

            $toggle.click(function() {
                if ($content.is(':visible')) {
                    $arrow.removeClass('active');
                    $content.slideUp(250);
                } else {
                    $arrow.addClass('active');
                    $content.slideDown(250);
                }
            });
        });
    });
});

// *******************************************************
// FUNCTION:    launchDialog
// PARAMETERS:  url (the video embed code URL)
// DESCRIPTION: Toggles (on and off) lDialog related modal window content
// *******************************************************
jQuery(document).ready(function($) {
    var triggers = $('.video-link');

    $(triggers).on("click", function(){
        var triggerEl = this;
        var vidID     = $(triggerEl).attr("data-video-url");

        launchDialog(vidID);
    });
});

function launchDialog(url) {
    if(url) {
        lDialog.open({
            content: '<div class="dialog-loading"><img class="vid-load-image" src="//d25ckoihpsjafc.cloudfront.net/rci-afvc/img/loader_large.gif"><p>Loading...</p></div>',
            ajax: {
                url: url,
                options: { evalScripts: true }
            },
            autofocusFirstFocusableElement: false
        });
    }
}

// *******************************************************
// FUNCTION:    launchLoadingDialog
// PARAMETERS:  none
// DESCRIPTION: Toggles (on and off) lDialog related modal window laoding image html/text content
// *******************************************************

function launchLoadingDialog() {
    lDialog.open({
        content: '<div class="dialog-loading"><img class="vid-load-image" src="//s3.amazonaws.com/rciglobal-assets/rci-afvc/img/loader_large.gif"><p>Loading...</p></div>',
        closeOnOverlay: false,
        className: 'dialog-noclose',
        autofocusFirstFocusableElement: false
    });
}

// *******************************************************
// FUNCTION:    launchInfoDialog
// PARAMETERS:  divname
// DESCRIPTION: Toggles (on and off) lDialog related modal window content loading the divname html/text content.
// CLOSEABLE:   This style of dialog box can be closed by the user.
// *******************************************************
jQuery(document).ready(function($) {
    var triggers = $('.info-dialog');

    $(triggers).on("click", function(){
        var triggerEl    = this;
        var alertMessage = $(triggerEl).attr("data-alert-message");
        var message      = $(alertMessage).html();

        launchInfoDialog(message);
    });
});

function launchInfoDialog(message) {
    if (message) {
        lDialog.open({
            content: '<div>' + message + '</div>',
            autofocusFirstFocusableElement: false
        });
    }
}

function launchInfoDialogWithClass(message, closeOnOverlay, cssClass) {
    if (message) {
        lDialog.open({
            content: '<div class="ldialog-scroll-content">' + message + '</div>',
            closeOnOverlay: closeOnOverlay,
            className: cssClass
        });
    }
}

// *******************************************************
// FUNCTION:    launchMessageDialog
// PARAMETERS:  divname
// DESCRIPTION: Toggles (on and off) lDialog related modal window content loading the divname html/text content
// CLOSEABLE:   This style of dialog cannot be closed by the user.
// *******************************************************
jQuery(document).ready(function($) {
    var triggers = $('.message-dialog');

    $(triggers).on("click", function(){
        var triggerEl    = this;
        var alertMessage = $(triggerEl).attr("data-alert-message");
        var message      = $(alertMessage).html();

        launchMessageDialog(message);
    });
});

function launchMessageDialog(message) {
    if (message) {
        lDialog.open({
            content: '<div>' + message + '</div>',
            closeOnOverlay: false,
            className: 'dialog-noclose',
            autofocusFirstFocusableElement: false
        });
    }
}

// *******************************************************
// FUNCTION:    prepCKEditor
// PARAMETERS:  none
// DESCRIPTION: Enables CKEditor on the Admin Tools and other forms
// *******************************************************
jQuery(function prepCKEditor($) {
    $('.ckfinder-form').each(function(index, el) {

        var $form                  = $(this);
        var $submitBtn             = $form.find('.btn-submit');
        var $copyBtn               = $form.find('.btn-copy');
        var $deleteBtn             = $form.find('.delete-button');

        // Set the CKEDITOR WYSIWYG
        CKEDITOR.replaceAll('do_ckeditor');

        $submitBtn.click(function() {
            // On submit, update any hidden textareas with their CKEditor counterpart contents
            for(var instanceName in CKEDITOR.instances) {
                CKEDITOR.instances[instanceName].updateElement();
            }
            $form.submit();
        });
    });
});

// Allows the tools search results page drop down to work
jQuery(function($){
    $('.js-result-actions').change(function() {
        if($(this).val() !== '') {
            document.location.href = $(this).val();
        }
    });
});

// *******************************************************
// FUNCTION:    ugcUploader
// PARAMETERS:  none
// DESCRIPTION: Activates and loads the User Generated Content Uploader script in a modal window
// *******************************************************
jQuery(function ugcUploader($) {
    $('.user-generated-content').each(function(index, el) {

        $('.js-btn-uploader').on("click", function() {

            lDialog.open({
                content: '<div id="stackla-goconnect-widget" data-widget-id="5d7aaac56f129"></div><script type="text/javascript">(function (d) {var cdn = window.StacklaGoConnectConfig ? window.StacklaGoConnectConfig.cdn : "assetscdn.stackla.com";var t   = d.createElement("script");t.type  = "text/javascript";t.src   = "https://" + cdn + "/media/js/common/plugin_goconnect_embed.js";(document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]).appendChild(t);}(document));</script>',
                closeOnOverlay: false,
                autofocusFirstFocusableElement: false
            });

            $('.l-dialog-container-main').addClass('js-override-margin');

        });

    });
});

jQuery(function($) {

    $(document.body).on('click', '.js-scroll-to-item', function(event) {

        event.preventDefault();

        var $scrollToItemTrigger = $(this);
        var $scrollToItem = $('#' + $scrollToItemTrigger.data('scroll-to-item-id'));

        $('html, body').animate({
            scrollTop: $scrollToItem.offset().top - 80
        }, 500, function() {
            if ($scrollToItem.hasClass('accordion-item')) {
                if (! $scrollToItem.find('.accordion-content').is(':visible')) {
                    $scrollToItem.find('.accordion-title').click();
                }
            }
        });
    });
});

jQuery(function($) {

    $(document.body).on('click', '.js-toggle-password-display', function() {

        var $clickedOnToggle = $(this);
        var toggleType       = $clickedOnToggle.data('password-display');
        var $formGroup       = $clickedOnToggle.closest('.form-group');
        var $passwordInput   = $formGroup.find('.js-toggle-password-input');

        if (toggleType === 'show') {

            $clickedOnToggle.data('password-display','hide');
            $clickedOnToggle.addClass('fa-eye-slash');
            $passwordInput.attr('type','text');
        }
        else {

            $clickedOnToggle.data('password-display','show');
            $clickedOnToggle.removeClass('fa-eye-slash');
            $passwordInput.attr('type','password');
        }

    });
});

jQuery(document).ready(function($) {

    if (window.location.hash) {

        var hash = window.location.hash.substring(1);

        if (hash.startsWith('scrollto-')) {

            var scrollToItemId = hash.replace('scrollto-', '')

            var $scrollToItemTriggerElement = $('.js-scroll-to-item[data-scroll-to-item-id="' + scrollToItemId + '"]');

            if ($scrollToItemTriggerElement.length) {
                $scrollToItemTriggerElement.trigger('click');
            }
        }
    }
});

jQuery(function($) {
    function openFeaturedTab(tabName) {
        $('.js-featured-description').each(function() {
            $(this).hide();
        });
        $(tabName).show();

        $('.btn-featured-tab').each(function() {
            $(this).removeClass('current');
        });
        $(tabName + '-tab').addClass('current');
    }
    window.openFeaturedTab = openFeaturedTab;
});
